import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventsState } from './events.state';

export const selectEventsState = createFeatureSelector<EventsState>('adminEvents');

export const selectAllEvents = createSelector(
  selectEventsState,
  (state) => state.events,
);

export const selectEventsLoading = createSelector(
  selectEventsState,
  (state) => state.loading,
);

export const selectEventsError = createSelector(
  selectEventsState,
  (state) => state.error,
);

export const selectSelectedEvent = createSelector(
  selectEventsState,
  (state) => state.selectedEvent,
);

export const selectEventsPagination = createSelector(
  selectEventsState,
  (state) => state.pagination,
);

export const selectEventById = (id: string) => createSelector(
  selectAllEvents,
  (events) => events.find(event => event.id === id),
);

